// Szolgáltatás-hozzárendelés státusz-badge — a jel a KÖZÖS badge-katalógus `lifecycle` fogalmából
// (`domain-badge.tsx`), ugyanabból, amit az ügyfél- és a fiók-badge is használ: az `active`/`pending`/`inactive`
// hármas ugyanazt jelenti mindhárom doménben, tehát ugyanúgy is kell kinéznie. (Korábban ez a badge ikon
// NÉLKÜL, és az `inactive`-ra `muted` színnel rendert — így az ügyfél-detail Fiókok sorain volt pipa, a
// Szolgáltatások sorain nem.)
import { DomainBadge } from '@/components/shared/domain-badge';

export interface ServiceStatusBadgeProps {
  status: string;
  /** A megjelenített (lokalizált) címke — a hívó adja `t('serviceAssignments.statusLabel.…')`-ből. */
  label: string;
  className?: string;
}

export function ServiceStatusBadge({
  status,
  label,
  className,
}: ServiceStatusBadgeProps): JSX.Element {
  return <DomainBadge kind="lifecycle" value={status} label={label} className={className} />;
}
